module.exports = "/_next/static/images/property-632d87c550907e46f07a70f3216332db.png";